export const SignatureView = () => {
    return (
        <div className="signature">
            <p className="name">Adam Trujillo</p>
            <p className="email"><a href="mailto:adam@rezio.net">adam@rezio.net</a></p>
        </div>
    )
}
